import React, { useEffect, useRef, useState } from 'react';
import { useMenu, useRange } from 'react-instantsearch';
import { Slider } from 'primereact/slider';
import css from './Filters.module.css';
import { capitalize, create } from 'lodash';
import classNames from 'classnames';
import { filterVariable } from '../../util/constant';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Button } from '../../components';

const FILTERS = [
  { attribute: 'price.amount', label: 'Price', key: 'price' },
  { attribute: 'publicData.categoryLevel2', label: 'Deal Type', key: 'dealType' },
];

const PriceFilter = props => {
  const { label } = props;
  const { start, range, refine } = useRange({ attribute: props.attribute });
  const { min, max } = range;
  const [value, setValue] = useState([min, max]);
  const from = Math.max(min, Number.isFinite(start[0]) ? start[0] : min);
  const to = Math.min(max, Number.isFinite(start[1]) ? start[1] : max);

  useEffect(() => {
    setValue([from, to]);
  }, [from, to]);
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef(null);
  const handleOutsideClick = event => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isOpen]);
  return (
    <>
      {isOpen ? <div className={css.closeWrapper}></div> : null}
      <div className={css.menuPopup} ref={popupRef}>
        <div onClick={() => setIsOpen(!isOpen)} className={css.menuButton}>
          {capitalize(label)}
        </div>
        {isOpen ? (
          <div className={classNames(css.popupContent, css.pricePopup)}>
            <div className={css.sliderLabels}>
              <span> {capitalize(label)}</span> <span>{`${from} - ${to}`}</span>
            </div>
            <Slider
              className={css.slider}
              value={value}
              min={min}
              max={max}
              onChange={e => {
                setValue(e.value);
                refine(e.value);
              }}
              range
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

const MenuSelect = props => {
  const { label, selectParams, onSelect } = props;
  const attributeLabel = props.attribute;
  const isSelected = filterVariable[selectParams[0]] === attributeLabel;

  const { items, refine, createURL } = useMenu({ attribute: attributeLabel });
  const { value: selectedValue } = items.find(item => item.isRefined) || { value: label };

  useEffect(() => {
    if (isSelected) {
      refine(selectParams[1]);
    }
  }, [isSelected, refine, selectParams]);

  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef(null);

  const handleItemClick = value => {
    refine(value);
    setIsOpen(false);
    onSelect(value); // Call the onSelect callback with the selected value
  };

  const handleOutsideClick = event => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isOpen]);

  return (
    <>
      {isOpen ? <div className={css.closeWrapper}></div> : null}
      <div className={css.menuPopup} ref={popupRef}>
        <div onClick={() => setIsOpen(!isOpen)} className={css.menuButton}>
          {capitalize(
            selectedValue && selectedValue.length > 12
              ? selectedValue.slice(0, 7).concat('...')
              : selectedValue
          )}
        </div>
        {isOpen ? (
          <div className={css.popupContent}>
            <div className={css.popupContentInner}>
              {items.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    handleItemClick(item.value);
                  }}
                  className={classNames(css.popupItem, selectedValue === item.label && css.active)}
                >
                  {capitalize(item.label)} ({item.count})
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

const Filters = props => {
  const { location } = props;
  const history = useHistory(); // Add this line to use history
  const isSearchParamsAdded = decodeURIComponent(location.search);
  const selectParams = isSearchParamsAdded.slice(1).split('=');

  const [selectedFilters, setSelectedFilters] = useState({});

  const updateURL = filters => {
    const query = new URLSearchParams(filters).toString();
    history.push({ search: query });
  };

  const handleFilterSelect = (attribute, value) => {
    setSelectedFilters(prevFilters => {
      const newFilters = {
        ...prevFilters,
        [attribute]: value,
      };
      updateURL(newFilters);
      return newFilters;
    });
  };

  useEffect(() => {
    // Parse the URL parameters and set the initial state
    const query = new URLSearchParams(location.search);
    const filters = {};
    query.forEach((value, key) => {
      filters[key] = value;
    });
    setSelectedFilters(filters);
  }, [location.search]);

  const handleClear = e => {
    e.preventDefault();
    document.querySelector('#clearButton').click();
    props.onSearchStateChange({
      keywords: '',
      bounds: '', // Clear the 'keywords' from searchState
    });
    if (typeof window !== 'undefined') {
      history.push('/s/deals');
      window.location.reload(); // Reload the page
    }
  };

  return (
    <>
      {FILTERS.map((filter, index) => (
        <div className={css.filterBox} key={index}>
          {filter.key === 'price' ? (
            <PriceFilter attribute={filter.attribute} label={filter.label} />
          ) : (
            <MenuSelect
              attribute={filter.attribute}
              label={filter.label}
              selectParams={selectParams}
              onSelect={value => handleFilterSelect(filter.attribute, value)} // Pass the callback
            />
          )}
        </div>
      ))}
      <div id="clearButton" className={css.clearButton} onClick={e => handleClear(e)}>
        <Button style={{ width: 100 }} className={css.clearRefinements}>
          Clear
        </Button>
      </div>
    </>
  );
};

export default Filters;
